import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Axios from "axios";
import { portal_url } from "../utils/Api";
import { verify_email, verify_success } from "../images";

const EmailVerification = () => {
  useEffect(() => {
    verifyEmail(routeParams.key);
  }, []);

  //========== VARIABLE ============

  const routeParams = useParams();
  let getError = "";
  const [ischeck, setIsCheck] = useState(true);
  const [message, setMessage] = useState(
    "Your email is currently being verified"
  );
  const [subMessage, setSubMessage] = useState("Please wait ...");
  const [status, setStatus] = useState(false);

  //========== METHODS ============

  const verifyEmail = async (key) => {
    await Axios.post(`${portal_url}/api/verify_email`, {
      email_verification: key,
    })
      .then((res) => {
        setTimeout(() => {
          const data = res.data;
          if (data.status) {
            setIsCheck(false);
            setMessage("Email Verification Successfully");
            setSubMessage("Please go back to profile page and reload");
          } else {
            setIsCheck(false);
            setMessage("Sorry, Your email failed to be verified");
            setSubMessage("Please re-verify");
          }

          setStatus(data.status);
        }, 5000);
      })
      .catch((error) => {
        if (typeof error.response.data.message !== "undefined") {
          getError = error.response.data.message;

          setIsCheck(false);
          setMessage("Sorry, Your email failed to be verified");
          setSubMessage("Please re-verify");
        }
      });
  };

  return (
    <div>
      <img
        src={ischeck ? verify_email : status ? verify_success : verify_email}
        alt=""
        className="img-fluid verify-image"
        style={{
          display: "block",
          marginTop: "80px",
          marginLeft: "auto",
          marginRight: "auto",
        }}
      />
      <center>
        <h2 style={{ marginLeft: "5px", marginRight: "5px" }}>{message}</h2>
        {ischeck ? (
          <h5 className="blink" style={{ marginTop: "15px" }}>
            {subMessage}{" "}
          </h5>
        ) : (
          <h5
            style={{ marginLeft: "5px", marginRight: "5px", marginTop: "15px" }}
          >
            {subMessage}{" "}
          </h5>
        )}
      </center>
    </div>
  );
};

export default EmailVerification;
